const LINKS = {
  TERMS_OF_SERVICE: "/information/terms_of_service.html",
  PASSWORD_RESET: "/kiban/com/csComReqPwd.do",
  ABOUT_LOGIN: "/customer_support/about_login.html",
} as const

export default LINKS
